

const toastPosition = {
    top_left:       'top-left',
    top_center:     'top-center',
    top_right:      'top-right',
    middle_left:    'middle-left',
    middle_center:  'middle-center',
    middle_right:   'middle-right',
    bottom_left:    'bottom-left',
    bottom_center:  'bottom-center',
    bottom_right:   'bottom-right',
    custom:         ''
};

const toastPositionClass = {};
toastPositionClass[toastPosition.top_left] = ['top-0', 'start-0'];
toastPositionClass[toastPosition.top_center] = ['top-0', 'start-50', 'translate-middle-x'];
toastPositionClass[toastPosition.top_right] = ['top-0', 'end-0'];
toastPositionClass[toastPosition.middle_left] = ['top-50', 'start-0', 'translate-middle-y'];
toastPositionClass[toastPosition.middle_center] = ['top-50', 'start-50', 'translate-middle'];
toastPositionClass[toastPosition.middle_right] = ['top-50', 'end-0', 'translate-middle-y'];
toastPositionClass[toastPosition.bottom_left] = ['bottom-0', 'start-0'];
toastPositionClass[toastPosition.bottom_center] = ['bottom-0', 'start-50', 'translate-middle-x'];
toastPositionClass[toastPosition.bottom_right] = ['bottom-0', 'end-0'];
toastPositionClass[toastPosition.custom] = [];

const defaultOptions = {
    animation:      true,
    autohide:       true,
    delay:          3000,
    position:       'top-right',
    containerClassList: [],
    toastClassList:     ['bg-primary', 'text-light'],
    headerClassList:    [],
    bodyClassList:      [],
    bodyContent:    '',
    headerContent:   '',
    closeButton:    true,
    hideOthers:     false,
    onShow:         null,
    onShown:        null,
    onHide:         null,
    onHidden:       null,
    autoShow:       false
};

export const { top_left, top_center, top_right, middle_left, middle_center, middle_right, bottom_left, bottom_center, bottom_right } = toastPosition;

export class Toast
{

    constructor(options = {})
    {
        this.returnObj = {

        };
        this.toastElem = null;

        for (const [key, value] of Object.entries(options)) {
            // remove any invalid options
            if (Object.keys(defaultOptions).indexOf(key) === -1) {
                delete options[key];
                continue;
            }
        }

        for (const [defaultOptionsKey, defaultOptionsValue] of Object.entries(defaultOptions)) {
            if (['containerClassList', 'toastClassList', 'headerClassList', 'bodyClassList'].indexOf(defaultOptionsKey) != -1) {
                if (typeof options[defaultOptionsKey] === 'string') {
                    options[defaultOptionsKey] = [options[defaultOptionsKey]];
                }
                if (typeof defaultOptionsValue === 'object' && typeof options[defaultOptionsKey] === 'object') {
                    // handle classList arrays
                    options[defaultOptionsKey].forEach(optionsClassListValue => {
                        const dashIdx = optionsClassListValue.indexOf('-');
                        // remove default options classlist items that are similar to those in options classlist value
                        defaultOptionsValue.forEach(defaultOptionsClassListValue => {
                            if (defaultOptionsClassListValue === optionsClassListValue || (dashIdx !== -1 && defaultOptionsClassListValue.substr(0, dashIdx) == optionsClassListValue.substr(0, dashIdx))) {
                                const idx = defaultOptionsValue.indexOf(defaultOptionsClassListValue);
                                defaultOptionsValue.splice(idx, 1);
                            }
                        });
                     });
                    // merge any remaining default option classlist items into passed options
                    options[defaultOptionsKey] = options[defaultOptionsKey].concat(defaultOptionsValue);
                } else {
                    options[defaultOptionsKey] = defaultOptionsValue;
                }
             } else {
                options[defaultOptionsKey] = options[defaultOptionsKey] || defaultOptionsValue;
            }
        }

        this.create(options);
        this.options = options;
        if (this.options.autoShow) {
            this.show();
        }
    }

    create(options)
    {

       this.toastElem = document.createElement('div');
        this.toastElem.classList.add('toast');
        console.log(options);
        options.toastClassList.forEach(elem => {
            this.toastElem.classList.add(elem);
        });
        this.toastElem.attributes.role = 'alert';
        this.toastElem.attributes['aria-live'] = 'assertive';
        this.toastElem.attributes['aria-atomic'] = true;

        const toastHeaderElem = this.toastElem.appendChild(document.createElement('div'));
        toastHeaderElem.classList.add('toast-header');
        options.headerClassList.forEach(elem => {
            toastHeaderElem.classList.add(elem);
        });
        const headerTextElem = toastHeaderElem.appendChild(document.createElement('strong'));
        headerTextElem.classList.add('me-auto');
        headerTextElem.textContent = options.headerContent;

        if (options.closeButton) {
            const closeButton = toastHeaderElem.appendChild(document.createElement('button'));
            closeButton.classList.add('btn-close');
            closeButton.attributes.type = 'button';
            closeButton.attributes['aria-label'] = 'Close';
            closeButton.dataset.bsDismiss = 'toast';
        }

        const toastBodyElem = this.toastElem.appendChild(document.createElement('div'));
        toastBodyElem.classList.add('toast-body');
        options.bodyClassList.forEach(elem => {
            toastBodyElem.classList.add(elem);
        });
        toastBodyElem.innerHTML = options.bodyContent;


        this.toast = new bootstrap.Toast(this.toastElem, this.extractToastOptions(options));
        this.initEventHandlers(this.toastElem);
    }

    extractToastOptions(options)
    {
        const bsOptions = {
            animation: options.animation,
            autohide: options.autohide,
            delay: options.delay
        };
        return bsOptions;
    }

    initEventHandlers(toastElem)
    {
        this.onHidden = this.onHidden.bind(this);
        toastElem.addEventListener('hidden.bs.toast', this.onHidden);
    }

    show()
    {
        let toastContainerElem = document.body.querySelector('.toast-container');
        if (!toastContainerElem) {
            toastContainerElem = document.createElement('div');
            toastContainerElem.classList.add('toast-container');
            this.options.containerClassList.forEach(elem => {
                toastContainerElem.classList.add(elem);
            });
            if (typeof this.options.position !== 'undefined') {
                toastPositionClass[this.options.position].forEach(elem => {
                    toastContainerElem.classList.add(elem);
                });
            }
            const dialog = document.querySelector('dialog');
            if (dialog && dialog.hasAttribute('open')) {
                dialog.appendChild(toastContainerElem);
                console.log('showing toast in dialog');
            } else {
                document.body.appendChild(toastContainerElem);
            }
        }

        if (this.options.hideOthers) {

            const currentToasts = toastContainerElem.querySelectorAll('.toast');
            if (typeof this.options.hideOthers == "number") {
                setTimeout(() => {
                    currentToasts.forEach(elem => {
                        const toast = bootstrap.Toast.getInstance(elem);
                        if (toast) {
                            toast.hide();
                        }
                    });
                    this.showToast(toastContainerElem);
                }, this.options.hideOthers);
            } else if (Boolean(this.options.hideOthers)) {
                currentToasts.forEach(elem => {
                    const toast = bootstrap.Toast.getInstance(elem);
                    if (toast) {
                        toast.hide();
                    }
                });
                this.showToast(toastContainerElem);
            }
        } else {
            this.showToast(toastContainerElem);
        }

    }

    showToast(toastContainerElem)
    {
        toastContainerElem.appendChild(this.toastElem);

        if (typeof this.options.onShow === 'function') {
            this.toastElem.addEventListener('show.bs.toast', this.options.onShow);
        }
        if (typeof this.options.onShown === 'function') {
            this.toastElem.addEventListener('shown.bs.toast', this.options.onShown);
        }
        if (typeof this.options.onHide === 'function') {
            this.toastElem.addEventListener('hide.bs.toast', this.options.onHide);
        }

        this.toast.show();
    }

    onHidden(event)
    {
        if (typeof this.options.onHidden === 'function') {
            this.options.onHidden(event);
        }

        if (typeof this.options.onShow === 'function') {
            this.toastElem.removeEventListener('show.bs.toast', this.options.onShow);
        }
        if (typeof this.options.onShown === 'function') {
            this.toastElem.removeEventListener('shown.bs.toast', this.options.onShown);
        }
        if (typeof this.options.onHide === 'function') {
            this.toastElem.removeEventListener('hide.bs.toast', this.options.onHide);
        }
        this.toastElem.removeEventListener('hidden.bs.toast', this.onHidden);
        const containerElem = event.target.closest('.toast-container');
        event.target.remove();
        if (!containerElem.hasChildNodes()) {
            containerElem.remove();
        }
    }

}
